import { format as format_1 } from "date-fns";
import { utcNow, compare, now as now_1, toUniversalTime } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { toArray, map, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { int32ToString, createObj, equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { AttendanceStatus, Event$, User_$reflection, EventAttendee_$reflection, AttendanceStatus_$reflection, CompletedTask_$reflection, Event$_$reflection, Role } from "../Shared/SharedModels.jsx";
import { SkeletonItem, Skeleton, CounterBadge, Tab, TabList, Avatar, Tooltip, PopoverSurface, PopoverTrigger, Popover, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger, Menu, ProgressBar, Title3, Subtitle1, Text as Text$, Caption1, InfoLabel, Body2, Subtitle2, CardHeader, Card, Link, Persona, Caption1Strong, Body1, DialogSurface, DialogBody, Button, DialogActions, Checkbox, Body1Strong, DialogContent, DialogTitle, Dialog, tokens } from "@fluentui/react-components";
import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type, int32_type, record_type, array_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { indexed, append } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Report, Course, Task, toastServerError, Event$ as Event$_1 } from "../ApiClient.jsx";
import { successToast, errorToast } from "../Toasts.jsx";
import { RouterModule_encodeParts, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "../Context.jsx";
import { CircleRegular, CheckmarkRegular, QuestionRegular, OpenRegular, DocumentArrowDownRegular, MailRegular, CalendarLtrRegular, MoreVerticalRegular, LocationRegular, ClockLockRegular, CalendarRegular, HatGraduationRegular, BookOpenRegular, PersonArrowRightRegular, PeopleListRegular, CheckboxPersonRegular, LockClosedRegular, ClockRegular, PersonDeleteRegular, CheckmarkStarburstFilled, DeleteRegular, DismissRegular, WarningFilled } from "@fluentui/react-icons";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tryHead, collect, exists, map as map_1, empty, singleton as singleton_1, append as append_1, delay, toList, take, length } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { nb } from "date-fns/locale";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { notFoundView, relativeDayLabel, formatDuration, formatStarter } from "../Helpers.jsx";
import { max, min } from "../fable_modules/fable-library-js.4.29.0/Double.js";
import { Dialog as Dialog_1 } from "./EditEvent.jsx";
import { Panel, canCloseSignup, CloseSignupDialog } from "./AttendeesPanel.jsx";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { ByteArrayExtensions_SaveFileAs_5EF83E14 } from "../fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";

function mapsUrl(address) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

function mapsEmbedUrl(address) {
    return `https://maps.google.com/maps?q=${encodeURIComponent(address)}&z=15&output=embed`;
}

function googleCalendarUrl(event) {
    const utc = (d) => format_1(toUniversalTime(d), "yyyyMMdd\'T\'HHmmss\'Z\'");
    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.Name)}&dates=${encodeURIComponent(`${utc(event.Time)}/${utc(event.EndTime)}`)}&details=${encodeURIComponent(defaultArg(event.Description, event.Summary))}&location=${encodeURIComponent(event.Address)}`;
}

function outlookCalendarUrl(event) {
    const utc = (d) => format_1(toUniversalTime(d), "yyyy-MM-dd\'T\'HH:mm:ss\'Z\'");
    return `https://outlook.office.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(event.Name)}&body=${encodeURIComponent(defaultArg(event.Description, event.Summary))}&location=${encodeURIComponent(event.Address)}&startdt=${encodeURIComponent(utc(event.Time))}&enddt=${encodeURIComponent(utc(event.EndTime))}`;
}

function isUserEventTeacher(user, event) {
    if (user.Id === event.Teacher.Id) {
        return true;
    }
    else {
        return event.SecondaryTeachers.some((t) => (t.Id === user.Id));
    }
}

function canUserManageEvent(user, event) {
    if (equals(user.Role, new Role(1, []))) {
        return true;
    }
    else if (equals(user.Role, new Role(2, [])) ? true : equals(user.Role, new Role(3, []))) {
        return isUserEventTeacher(user, event);
    }
    else {
        return false;
    }
}

function eventLifecycle(event) {
    const now = now_1();
    if (event.Finalized ? true : (compare(event.EndTime, now) <= 0)) {
        return ["Avsluttet", tokens.colorNeutralForeground3, tokens.colorNeutralBackground3];
    }
    else if (compare(event.Time, now) <= 0) {
        return ["Pågår", tokens.colorPaletteLightGreenForeground1, tokens.colorPaletteLightGreenBackground2];
    }
    else {
        return undefined;
    }
}

function statusFor(canManage, isEligible, event, status) {
    const matchValue = eventLifecycle(event);
    if (matchValue == null) {
        if (canManage) {
            return ["Du underviser", tokens.colorBrandForeground1, tokens.colorBrandBackground2];
        }
        else {
            switch (status.tag) {
                case 1:
                    return ["Avventer plass", tokens.colorPaletteRoyalBlueForeground2, tokens.colorPaletteRoyalBlueBackground2];
                case 3:
                    return ["På venteliste", tokens.colorPaletteMarigoldForeground1, tokens.colorPaletteMarigoldBackground2];
                case 0:
                    if (isEligible) {
                        return ["Tilgjengelig", tokens.colorBrandForeground1, tokens.colorBrandBackground2];
                    }
                    else {
                        return ["Ikke tilgjengelig", tokens.colorNeutralForeground1, tokens.colorNeutralBackground6];
                    }
                default:
                    return ["Plass bekreftet", tokens.colorPaletteGreenForeground2, tokens.colorPaletteGreenBackground2];
            }
        }
    }
    else {
        return matchValue;
    }
}

class Model extends Record {
    constructor(Event$, IsFetchingEventDetails, UserCompletedTasks, UserIsEligible, UserAttendanceStatus, SignedUpDialogOpen, WithdrawConfirmDialogOpen) {
        super();
        this.Event = Event$;
        this.IsFetchingEventDetails = IsFetchingEventDetails;
        this.UserCompletedTasks = UserCompletedTasks;
        this.UserIsEligible = UserIsEligible;
        this.UserAttendanceStatus = UserAttendanceStatus;
        this.SignedUpDialogOpen = SignedUpDialogOpen;
        this.WithdrawConfirmDialogOpen = WithdrawConfirmDialogOpen;
    }
}

function Model_$reflection() {
    return record_type("Event.EventView.Model", [], Model, () => [["Event", option_type(Event$_$reflection())], ["IsFetchingEventDetails", bool_type], ["UserCompletedTasks", array_type(CompletedTask_$reflection())], ["UserIsEligible", bool_type], ["UserAttendanceStatus", AttendanceStatus_$reflection()], ["SignedUpDialogOpen", bool_type], ["WithdrawConfirmDialogOpen", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEvent", "SetIsFetching", "UpdateUserCompletedTasks", "UpdateUserIsEligible", "UpdateUserAttendanceStatus", "SignedUp", "Withdrew", "CompleteTask", "RevokeTask", "UpdateSignedUpDialogOpen", "UpdateWithdrawConfirmDialogOpen"];
    }
}

function Msg_$reflection() {
    return union_type("Event.EventView.Msg", [], Msg, () => [[["Item", option_type(Event$_$reflection())]], [["Item", bool_type]], [["Item", array_type(CompletedTask_$reflection())]], [["Item", bool_type]], [["Item", AttendanceStatus_$reflection()]], [["Item", EventAttendee_$reflection()]], [["Item", User_$reflection()]], [["Item", CompletedTask_$reflection()]], [["Item", int32_type]], [["Item", bool_type]], [["Item", bool_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Event, msg.fields[0], model.UserCompletedTasks, model.UserIsEligible, model.UserAttendanceStatus, model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 2:
            return new Model(model.Event, model.IsFetchingEventDetails, msg.fields[0], model.UserIsEligible, model.UserAttendanceStatus, model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 3:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, msg.fields[0], model.UserAttendanceStatus, model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 4:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, model.UserIsEligible, msg.fields[0], model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 5:
            return new Model(map((event_1) => (new Event$(event_1.Id, event_1.Name, event_1.Enabled, event_1.Summary, event_1.Description, event_1.Address, event_1.MaxAttendees, event_1.AttendeeCount + 1, event_1.Time, event_1.EndTime, event_1.SignupDeadline, event_1.DateDescription, event_1.Finalized, event_1.Course, event_1.Teacher, event_1.SecondaryTeachers, event_1.Region)), model.Event), model.IsFetchingEventDetails, model.UserCompletedTasks, model.UserIsEligible, new AttendanceStatus(1, []), model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 6:
            return new Model(map((event_2) => (new Event$(event_2.Id, event_2.Name, event_2.Enabled, event_2.Summary, event_2.Description, event_2.Address, event_2.MaxAttendees, event_2.AttendeeCount - 1, event_2.Time, event_2.EndTime, event_2.SignupDeadline, event_2.DateDescription, event_2.Finalized, event_2.Course, event_2.Teacher, event_2.SecondaryTeachers, event_2.Region)), model.Event), model.IsFetchingEventDetails, model.UserCompletedTasks, model.UserIsEligible, new AttendanceStatus(0, []), model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 7:
            return new Model(model.Event, model.IsFetchingEventDetails, append([msg.fields[0]], model.UserCompletedTasks), model.UserIsEligible, model.UserAttendanceStatus, model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 8:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks.filter((ct) => (ct.Task.Id !== msg.fields[0])), model.UserIsEligible, model.UserAttendanceStatus, model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
        case 9:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, model.UserIsEligible, model.UserAttendanceStatus, msg.fields[0], model.WithdrawConfirmDialogOpen);
        case 10:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, model.UserIsEligible, model.UserAttendanceStatus, model.SignedUpDialogOpen, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.IsFetchingEventDetails, model.UserCompletedTasks, model.UserIsEligible, model.UserAttendanceStatus, model.SignedUpDialogOpen, model.WithdrawConfirmDialogOpen);
    }
}

function init() {
    return new Model(undefined, true, [], false, new AttendanceStatus(0, []), false, false);
}

function Promises_fetchEvent(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Get(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            dispatch(new Msg(1, [false]));
        }
        else {
            dispatch(new Msg(0, [res.fields[0]]));
        }
        return res;
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_checkIsAttending(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.CheckOwnAttendance(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(4, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_fetchUserCompletedTasks(dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Task.GetMyCompleted());
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(2, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_checkIsEligible(courseId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Course.CheckOwnEligibility(courseId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(3, [res.fields[0]]));
        }
        dispatch(new Msg(1, [false]));
    }));
    void (pr_1.catch((arg) => {
        const _arg = toastServerError(setCtx, arg);
        dispatch(new Msg(1, [false]));
    }));
}

function Promises_signUp(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.SignUp(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, "signUpErrorNotQualified", "Kunne ikke melde på", "Du er ikke kvalifisert for dette arrangementet", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, "signUpErrorDeadline", "Kunne ikke melde på", "Påmeldingsfristen er gått ut", undefined);
                    break;
                }
                case 3: {
                    errorToast(setCtx, "signUpErrorInactiveTrack", "Kunne ikke melde på", "Kurs er del av inaktivt nivå", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "signUpError", "Kunne ikke melde på", "Kunne ikke finne arrangement å melde på", undefined);
            }
        }
        else {
            dispatch(new Msg(5, [res.fields[0]]));
            dispatch(new Msg(9, [true]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_withdraw(eventId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Withdraw(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 2: {
                    dispatch(new Msg(4, [new AttendanceStatus(0, [])]));
                    break;
                }
                case 1: {
                    errorToast(setCtx, "withdrawUserNotFound", "Kunne ikke melde av", "Noe gikk galt", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "withdrawEventNotFound", "Kunne ikke melde av", "Kunne ikke finne arrangement å melde av", undefined);
            }
        }
        else {
            dispatch(new Msg(6, [self]));
            successToast(setCtx, "withdrawEventSuccess", "Avmeldt", "Du ble meldt av arrangementet");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_completeTask(eventId, taskId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Task.CompleteCourseTask(taskId, new Int32Array([self.Id]), eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, `completeTask${taskId}Error`, "Kunne ikke sette oppgave som fullført", "Noe gikk galt", undefined);
        }
        else {
            dispatch(new Msg(7, [res.fields[0]]));
            successToast(setCtx, `completeTask${taskId}Success`, "Oppgave fullført", "Oppgaven ble satt som fullført");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_revokeTask(eventId, taskId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Task.RevokeCourseTask(taskId, new Int32Array([self.Id]), eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, `revokeTask${taskId}Error`, "Kunne ikke sette oppgave som ikke fullført", "Noe gikk galt", undefined);
        }
        else {
            dispatch(new Msg(8, [taskId]));
            successToast(setCtx, `revokeTask${taskId}Success`, "Oppgave satt som ikke fullført", "Oppgaven ble satt som ikke fullført");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_deleteEvent(eventId, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Delete(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 1) {
                errorToast(setCtx, "deleteEventHasAttendees", "Kunne ikke slette", "Arrangementet har deltakere", undefined);
            }
            else {
                errorToast(setCtx, "deleteEventNotFound", "Kunne ikke slette", "Arrangementet ble ikke funnet", undefined);
            }
        }
        else {
            successToast(setCtx, "deleteEventSuccess", "Slettet", "Arrangementet ble slettet");
            RouterModule_nav(ofArray(["arrangement"]), 1, 1);
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function DeleteEventDialog(deleteEventDialogInputProps) {
    let elems_3, props_34, props_32, el, el_8, elems, el_2, el_4, el_6, el_14, elems_1, el_12, el_10, el_20, elems_2, el_18, el_16, name, name_2, elemsToUse;
    const setIsOpen = deleteEventDialogInputProps.setIsOpen;
    const isOpen = deleteEventDialogInputProps.isOpen;
    const event = deleteEventDialogInputProps.event;
    const patternInput = reactApi.useState(false);
    const setHasConfirmed = patternInput[1];
    const hasConfirmed = patternInput[0];
    const patternInput_1 = useCtx();
    const el_22 = Dialog;
    return createElement(el_22, createObj(ofArray([["open", isOpen], ["onOpenChange", (_arg, value_1_1) => {
        const d = value_1_1;
        setIsOpen(d.open);
        if (!d.open) {
            setHasConfirmed(false);
        }
    }], (elems_3 = [(props_34 = singleton((props_32 = ofArray([(el = DialogTitle, createElement(el, {
        children: "Slett arrangement",
    })), (el_8 = DialogContent, createElement(el_8, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_2 = WarningFilled, createElement(el_2, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_4 = Body1Strong, createElement(el_4, {
        style: {
            textAlign: "center",
        },
        children: `Er du sikker på at du vil slette arrangementet "${event.Name}"? Det vil ikke være mulig å angre denne handlingen.`,
    })), (el_6 = Checkbox, createElement(el_6, {
        label: "Ja, jeg er sikker",
        checked: hasConfirmed,
        onChange: (_arg_1, c) => {
            setHasConfirmed(Checkbox_toBool(c));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_14 = DialogActions, createElement(el_14, createObj(ofArray([["position", "start"], (elems_1 = [(el_12 = Button, createElement(el_12, {
        icon: (el_10 = DismissRegular, createElement(el_10, {})),
        children: "Avbryt",
        onClick: (_arg_2) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "end"], (elems_2 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DeleteRegular, createElement(el_16, {})),
        appearance: "primary",
        children: "Slett",
        disabled: !hasConfirmed,
        onClick: (_arg_3) => {
            setIsOpen(false);
            Promises_deleteEvent(event.Id, patternInput_1[1]);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_32)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_34)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function SignedUpDialog(signedUpDialogInputProps) {
    let elems_2, props_22, props_20, el, el_8, elems, el_2, el_4, el_6, locale, formatOptions, el_12, elems_1, el_10, name, name_2, elemsToUse;
    const dispatch = signedUpDialogInputProps.dispatch;
    const model = signedUpDialogInputProps.model;
    const event = signedUpDialogInputProps.event;
    const el_14 = Dialog;
    return createElement(el_14, createObj(ofArray([["open", model.SignedUpDialogOpen], ["onOpenChange", (_arg, value_1_1) => {
        dispatch(new Msg(9, [value_1_1.open]));
    }], (elems_2 = [(props_22 = singleton((props_20 = ofArray([(el = DialogTitle, createElement(el, {
        children: "Påmelding registrert",
    })), (el_8 = DialogContent, createElement(el_8, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_2 = CheckmarkStarburstFilled, createElement(el_2, {
        primaryFill: tokens.colorStatusSuccessForeground1,
        fontSize: 48,
    })), (el_4 = Body1Strong, createElement(el_4, {
        style: {
            textAlign: "center",
        },
        children: `Du er registrert på ${event.Name}`,
    })), (el_6 = Body1, createElement(el_6, {
        style: {
            textAlign: "center",
        },
        children: `Etter påmeldingsfristen ${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(event.SignupDeadline, "dd MMMM yyyy", formatOptions))))} får du en e-post med informasjon om du har fått tildelt plass eller blir satt på venteliste.`,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_12 = DialogActions, createElement(el_12, createObj(ofArray([["position", "end"], (elems_1 = [(el_10 = Button, createElement(el_10, {
        appearance: "primary",
        children: "Ok",
        onClick: (_arg_1) => {
            dispatch(new Msg(9, [false]));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_20)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_22)),
    })))], (elemsToUse = ((length(elems_2) <= 2) ? elems_2 : take(2, elems_2)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function WithdrawConfirmDialog(withdrawConfirmDialogInputProps) {
    let elems_3, props_34, props_32, el, el_8, elems, el_2, el_4, el_6, el_14, elems_1, el_12, el_10, el_20, elems_2, el_18, el_16, name, name_2, elemsToUse;
    const dispatch = withdrawConfirmDialogInputProps.dispatch;
    const model = withdrawConfirmDialogInputProps.model;
    const event = withdrawConfirmDialogInputProps.event;
    const patternInput = useCtx();
    const el_22 = Dialog;
    return createElement(el_22, createObj(ofArray([["open", model.WithdrawConfirmDialogOpen], ["onOpenChange", (_arg, value_1_1) => {
        dispatch(new Msg(10, [value_1_1.open]));
    }], (elems_3 = [(props_34 = singleton((props_32 = ofArray([(el = DialogTitle, createElement(el, {
        children: "Bekreft avmelding",
    })), (el_8 = DialogContent, createElement(el_8, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_2 = WarningFilled, createElement(el_2, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_4 = Body1Strong, createElement(el_4, {
        style: {
            textAlign: "center",
        },
        children: "Er du sikker på at du vil melde deg av dette arrangementet?",
    })), (el_6 = Body1, createElement(el_6, {
        style: {
            textAlign: "center",
        },
        children: "Du vil miste plassen din. Denne handlingen kan ikke angres.",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_14 = DialogActions, createElement(el_14, createObj(ofArray([["position", "start"], (elems_1 = [(el_12 = Button, createElement(el_12, {
        icon: (el_10 = DismissRegular, createElement(el_10, {})),
        children: "Avbryt",
        onClick: (_arg_1) => {
            dispatch(new Msg(10, [false]));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "end"], (elems_2 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = PersonDeleteRegular, createElement(el_16, {})),
        appearance: "primary",
        children: "Meld av",
        onClick: (_arg_2) => {
            dispatch(new Msg(10, [false]));
            Promises_withdraw(event.Id, patternInput[0].User, dispatch, patternInput[1]);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_32)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_34)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function MetaPair(metaPairInputProps) {
    let elems_2, elems_1, el, el_2;
    const value = metaPairInputProps.value;
    const label = metaPairInputProps.label;
    const icon = metaPairInputProps.icon;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 12 + "px ",
        minWidth: 0,
        flexGrow: 1,
        flexBasis: 0,
    }], (elems_2 = [createElement("div", {
        style: {
            width: 36,
            height: 36,
            borderRadius: 18,
            backgroundColor: tokens.colorNeutralBackground3,
            color: tokens.colorNeutralForeground2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
        },
        children: reactApi.Children.toArray([icon]),
    }), createElement("div", createObj(ofArray([["style", {
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
    }], (elems_1 = [(el = Caption1Strong, createElement(el, {
        style: {
            display: "block",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            color: tokens.colorNeutralForeground3,
        },
        children: label,
    })), (el_2 = Body1Strong, createElement(el_2, {
        style: {
            display: "block",
            color: tokens.colorNeutralForeground1,
        },
        children: value,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function TeacherChip(teacherChipInputProps) {
    let elems_1, el_2;
    const small = teacherChipInputProps.small;
    const canLink = teacherChipInputProps.canLink;
    const label = teacherChipInputProps.label;
    const teacher = teacherChipInputProps.teacher;
    let inner;
    const el = Persona;
    inner = createElement(el, createObj(toList(delay(() => append_1(singleton_1(["name", `${teacher.FirstName} ${teacher.LastName}`]), delay(() => append_1(singleton_1(["secondaryText", label]), delay(() => append_1(small ? singleton_1(["size", "small"]) : singleton_1(["size", "medium"]), delay(() => singleton_1(["avatar", {
        color: "colorful",
        image: {
            src: defaultArg(teacher.ThumbnailUrl, ""),
        },
    }])))))))))));
    if (canLink) {
        const el_4 = Link;
        return createElement(el_4, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(teacher.Id)]), 1)], (elems_1 = [(el_2 = Button, createElement(el_2, {
            size: "small",
            appearance: "subtle",
            children: reactApi_1.Children.toArray([inner]),
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
    }
    else {
        return createElement("div", {
            style: {
                padding: 4,
            },
            children: reactApi.Children.toArray([inner]),
        });
    }
}

function SectionEyebrow(sectionEyebrowInputProps) {
    const label = sectionEyebrowInputProps.label;
    const el = Caption1Strong;
    return createElement(el, {
        style: {
            display: "block",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            color: tokens.colorNeutralForeground3,
            marginBottom: 8,
        },
        children: label,
    });
}

function PrimaryAction(primaryActionInputProps) {
    let elems, el_4, el, el_2, el_6, elems_1, el_14, el_10, el_12, el_16, elems_7, elems_10, elems_13, elems_3, el_28, el_24, el_26, el_30, elems_4, el_38, el_34, el_36, el_40, elems_2, el_22;
    const dispatch = primaryActionInputProps.dispatch;
    const model = primaryActionInputProps.model;
    const event = primaryActionInputProps.event;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const isEventTeacher = isUserEventTeacher(ctx.User, event);
    if (compare(event.Time, now_1()) <= 0) {
        const el_8 = Card;
        return createElement(el_8, createObj(ofArray([["appearance", "outline"], (elems = [(el_4 = CardHeader, createElement(el_4, {
            image: (el = ClockRegular, createElement(el, {
                fontSize: 28,
            })),
            header: (el_2 = Subtitle2, createElement(el_2, {
                children: "Påmelding/Avmelding stengt",
            })),
        })), (el_6 = Body2, createElement(el_6, {
            children: "Fristen for påmelding/avmelding er passert.",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
    else if (!model.UserIsEligible) {
        const el_18 = Card;
        return createElement(el_18, createObj(ofArray([["appearance", "outline"], (elems_1 = [(el_14 = CardHeader, createElement(el_14, {
            image: (el_10 = LockClosedRegular, createElement(el_10, {
                fontSize: 28,
            })),
            header: (el_12 = Subtitle2, createElement(el_12, {
                children: "Ikke tilgjengelig",
            })),
        })), (el_16 = Body2, createElement(el_16, {
            children: "Dette arrangementet er på et nivå du ikke har tilgang til enda.",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
    }
    else {
        const signupDeadlinePassed = compare(event.SignupDeadline, now_1()) <= 0;
        const canWithdraw = !event.Finalized && (compare(event.Time, now_1()) > 0);
        const isBlockedByTrackInactive = ctx.InactiveTracks.some((it) => it.BlockedCourses.some((bc) => (bc.Id === event.Course.Id)));
        const matchValue = model.UserAttendanceStatus;
        switch (matchValue.tag) {
            case 1:
                return createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8 + "px ",
                }], (elems_7 = toList(delay(() => {
                    let el_50, elems_5, el_44, xs_2, el_46, el_48;
                    return append_1(singleton_1((el_50 = InfoLabel, createElement(el_50, createObj(ofArray([(elems_5 = [(el_44 = Caption1, createElement(el_44, {
                        children: "Avventer plass",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))]), ["info", (xs_2 = [(el_46 = Body1Strong, createElement(el_46, {
                        children: "Du er påmeldt, men ikke sikret plass.",
                    })), createElement("br", {}), (el_48 = Text$, createElement(el_48, {
                        children: "Du vil få beskjed om du er sikret plass etter påmeldingsfristen.",
                    }))], react.createElement(react.Fragment, {}, ...xs_2))]]))))), delay(() => {
                        let elems_6, el_54, el_52;
                        return (!signupDeadlinePassed && canWithdraw) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                            alignSelf: "flex-start",
                        }], (elems_6 = [(el_54 = Button, createElement(el_54, {
                            icon: (el_52 = DismissRegular, createElement(el_52, {})),
                            appearance: "secondary",
                            children: "Meld av",
                            onClick: (_arg_1) => {
                                Promises_withdraw(event.Id, ctx.User, dispatch, setCtx);
                            },
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
            case 2:
                return createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8 + "px ",
                }], (elems_10 = toList(delay(() => {
                    let elems_8, el_56, el_58;
                    return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 8 + "px ",
                        padding: ((10 + "px ") + 12) + "px",
                        borderRadius: 6,
                        backgroundColor: tokens.colorPaletteGreenBackground2,
                        color: tokens.colorPaletteGreenForeground2,
                    }], (elems_8 = [(el_56 = CheckboxPersonRegular, createElement(el_56, {
                        fontSize: 20,
                    })), (el_58 = Caption1, createElement(el_58, {
                        style: {
                            color: tokens.colorPaletteGreenForeground2,
                        },
                        children: "Plass bekreftet",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                        let elems_9, el_62, el_60;
                        return canWithdraw ? singleton_1(createElement("div", createObj(ofArray([["style", {
                            alignSelf: "flex-start",
                        }], (elems_9 = [(el_62 = Button, createElement(el_62, {
                            style: {},
                            icon: (el_60 = DismissRegular, createElement(el_60, {})),
                            appearance: "secondary",
                            children: "Meld av",
                            onClick: (_arg_2) => {
                                dispatch(new Msg(10, [true]));
                            },
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
            case 3:
                return createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8 + "px ",
                }], (elems_13 = toList(delay(() => {
                    let elems_11, el_64, el_66;
                    return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 8 + "px ",
                        padding: ((10 + "px ") + 12) + "px",
                        borderRadius: 6,
                        backgroundColor: tokens.colorPaletteMarigoldBackground2,
                        color: tokens.colorPaletteMarigoldForeground1,
                    }], (elems_11 = [(el_64 = PeopleListRegular, createElement(el_64, {
                        fontSize: 20,
                    })), (el_66 = Caption1, createElement(el_66, {
                        style: {
                            color: tokens.colorPaletteMarigoldForeground1,
                        },
                        children: "Du er på venteliste",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                        let elems_12, el_70, el_68;
                        return canWithdraw ? singleton_1(createElement("div", createObj(ofArray([["style", {
                            alignSelf: "flex-start",
                        }], (elems_12 = [(el_70 = Button, createElement(el_70, {
                            style: {},
                            icon: (el_68 = DismissRegular, createElement(el_68, {})),
                            appearance: "secondary",
                            children: "Meld av",
                            onClick: (_arg_3) => {
                                dispatch(new Msg(10, [true]));
                            },
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
            default:
                if (signupDeadlinePassed) {
                    const el_32 = Card;
                    return createElement(el_32, createObj(ofArray([["appearance", "outline"], (elems_3 = [(el_28 = CardHeader, createElement(el_28, {
                        image: (el_24 = ClockRegular, createElement(el_24, {
                            fontSize: 28,
                        })),
                        header: (el_26 = Subtitle2, createElement(el_26, {
                            children: "Påmelding stengt",
                        })),
                    })), (el_30 = Body2, createElement(el_30, {
                        children: "Påmeldingsfristen er passert.",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
                }
                else if (isBlockedByTrackInactive) {
                    const el_42 = Card;
                    return createElement(el_42, createObj(ofArray([["appearance", "outline"], (elems_4 = [(el_38 = CardHeader, createElement(el_38, {
                        image: (el_34 = WarningFilled, createElement(el_34, {
                            fontSize: 28,
                            primaryFill: tokens.colorStatusDangerBackground3,
                        })),
                        header: (el_36 = Subtitle2, createElement(el_36, {
                            children: "Påmelding ikke tilgjengelig",
                        })),
                    })), (el_40 = Body2, createElement(el_40, {
                        children: "Kurs ikke tilgjengelig pga. inaktivt læringsløp",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
                }
                else {
                    return createElement("div", createObj(ofArray([["style", {
                        alignSelf: "flex-start",
                    }], (elems_2 = [(el_22 = Button, createElement(el_22, createObj(toList(delay(() => {
                        let el_20;
                        return append_1(singleton_1(["icon", (el_20 = PersonArrowRightRegular, createElement(el_20, {}))]), delay(() => append_1(singleton_1(["disabled", ((!model.UserIsEligible ? true : (compare(event.Time, now_1()) <= 0)) ? true : isBlockedByTrackInactive) ? true : isEventTeacher]), delay(() => append_1(isEventTeacher ? singleton_1(["title", "Du kan ikke melde deg på ditt eget arrangement"]) : empty(), delay(() => append_1(singleton_1(["appearance", "primary"]), delay(() => append_1(singleton_1(["children", "Meld på"]), delay(() => singleton_1(["onClick", (_arg) => {
                            Promises_signUp(event.Id, dispatch, setCtx);
                        }])))))))))));
                    })))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
                }
        }
    }
}

function HeroCard(heroCardInputProps) {
    let elems_16, elems_3, elems_7, elems_14, elems_15;
    const canManage = heroCardInputProps.canManage;
    const dispatch = heroCardInputProps.dispatch;
    const model = heroCardInputProps.model;
    const event = heroCardInputProps.event;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const isAdmin = equals(ctx.User.Role, new Role(1, []));
    const patternInput_1 = reactApi.useState(false);
    const setCloseSignupOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setDeleteOpen = patternInput_2[1];
    const canViewProfile = (equals(ctx.User.Role, new Role(1, [])) ? true : equals(ctx.User.Role, new Role(2, []))) ? true : equals(ctx.User.Role, new Role(3, []));
    const patternInput_3 = statusFor(canManage, model.UserIsEligible, event, model.UserAttendanceStatus);
    const statusLabel = patternInput_3[0];
    const el_74 = Card;
    return createElement(el_74, createObj(ofArray([["style", {
        padding: 0,
        overflow: "hidden",
    }], (elems_16 = [createElement("div", createObj(ofArray([["style", {
        position: "relative",
        height: isMobile ? 160 : 220,
        backgroundColor: tokens.colorNeutralBackground3,
    }], (elems_3 = toList(delay(() => {
        let matchValue, url_1, elems, el;
        return append_1((matchValue = event.Course.ImageUrl, (matchValue != null) ? (!isNullOrWhiteSpace(matchValue) ? ((url_1 = matchValue, append_1(singleton_1(createElement("img", {
            src: url_1,
            alt: "",
            style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: 100 + "%",
                height: 100 + "%",
                objectFit: "cover",
            },
        })), delay(() => singleton_1(createElement("div", {
            style: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.45) 100%)",
            },
        })))))) : singleton_1(createElement("div", createObj(ofArray([["style", {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }], (elems = [(el = BookOpenRegular, createElement(el, {
            style: {
                fontSize: 96 + "px",
            },
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))) : singleton_1(createElement("div", createObj(ofArray([["style", {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }], (elems = [(el = BookOpenRegular, createElement(el, {
            style: {
                fontSize: 96 + "px",
            },
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))), delay(() => {
            let elems_2;
            return singleton_1(createElement("div", createObj(ofArray([["style", {
                position: "absolute",
                top: 14,
                left: 16,
                display: "flex",
                gap: 8 + "px ",
                flexWrap: "wrap",
            }], (elems_2 = toList(delay(() => {
                let el_2;
                return append_1((statusLabel.length > 0) ? singleton_1((el_2 = Caption1Strong, createElement(el_2, {
                    style: {
                        display: "inline-flex",
                        alignItems: "center",
                        padding: ((3 + "px ") + 9) + "px",
                        borderRadius: 14,
                        backgroundColor: patternInput_3[2],
                        color: patternInput_3[1],
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                    },
                    children: statusLabel,
                }))) : empty(), delay(() => {
                    let el_4, el_6;
                    return append_1((isAdmin && !event.Enabled) ? singleton_1((el_4 = Caption1Strong, createElement(el_4, {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            padding: ((3 + "px ") + 9) + "px",
                            borderRadius: 14,
                            backgroundColor: tokens.colorPaletteMarigoldBackground2,
                            color: tokens.colorPaletteMarigoldForeground1,
                        },
                        children: "Utkast",
                    }))) : ((isAdmin && event.Finalized) ? singleton_1((el_6 = Caption1Strong, createElement(el_6, {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            padding: ((3 + "px ") + 9) + "px",
                            borderRadius: 14,
                            backgroundColor: tokens.colorPaletteGreenBackground2,
                            color: tokens.colorPaletteGreenForeground2,
                        },
                        children: "Ferdigstilt",
                    }))) : empty()), delay(() => {
                        let elems_1, el_8, el_10;
                        return singleton_1(createElement("span", createObj(ofArray([["style", {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 4 + "px ",
                            padding: ((3 + "px ") + 9) + "px",
                            borderRadius: 14,
                            backgroundColor: tokens.colorNeutralBackground1,
                            color: tokens.colorNeutralForeground1,
                        }], (elems_1 = [(el_8 = HatGraduationRegular, createElement(el_8, {
                            fontSize: 16,
                        })), (el_10 = Caption1Strong, createElement(el_10, {
                            children: event.Course.Name,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(isMobile ? singleton_1(["padding", ((16 + "px ") + 16) + "px"]) : singleton_1(["padding", ((20 + "px ") + 24) + "px"]), delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["flexDirection", "column"]), delay(() => singleton_1(["gap", 4 + "px "]))))))))))], (elems_7 = toList(delay(() => {
        let el_12, el_14;
        return append_1(isMobile ? singleton_1((el_12 = Subtitle1, createElement(el_12, {
            style: {
                display: "block",
                lineHeight: 1.2,
                letterSpacing: "-0.3px",
                color: tokens.colorNeutralForeground1,
            },
            children: event.Name,
        }))) : singleton_1((el_14 = Title3, createElement(el_14, {
            style: {
                display: "block",
                lineHeight: 1.2,
                letterSpacing: "-0.3px",
                color: tokens.colorNeutralForeground1,
            },
            children: event.Name,
        }))), delay(() => {
            let el_16;
            return append_1((event.Summary.length > 0) ? singleton_1((el_16 = Caption1, createElement(el_16, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: event.Summary,
            }))) : empty(), delay(() => {
                let elems_4, el_18, el_20, el_22, locale, formatOptions, el_24;
                return append_1(singleton_1(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(isMobile ? append_1(singleton_1(["flexDirection", "column"]), delay(() => singleton_1(["gap", 10 + "px "]))) : append_1(singleton_1(["flexDirection", "row"]), delay(() => singleton_1(["gap", 24 + "px "]))), delay(() => append_1(singleton_1(["marginTop", 1 + "rem"]), delay(() => append_1(singleton_1(["paddingTop", 1 + "rem"]), delay(() => append_1(singleton_1(["borderTop", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2]), delay(() => singleton_1(["flexWrap", "wrap"]))))))))))))))], (elems_4 = [createElement(MetaPair, {
                    icon: (el_18 = CalendarRegular, createElement(el_18, {
                        fontSize: 20,
                    })),
                    label: "Starter",
                    value: formatStarter(event.Time),
                }), createElement(MetaPair, {
                    icon: (el_20 = ClockRegular, createElement(el_20, {
                        fontSize: 20,
                    })),
                    label: "Varighet",
                    value: formatDuration(event.Time, event.EndTime),
                }), createElement(MetaPair, {
                    icon: (el_22 = ClockLockRegular, createElement(el_22, {
                        fontSize: 20,
                    })),
                    label: "Påmeldingsfrist",
                    value: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(event.SignupDeadline, "d. MMMM yyyy", formatOptions))))} · ${relativeDayLabel(event.SignupDeadline)}`,
                }), createElement(MetaPair, {
                    icon: (el_24 = LocationRegular, createElement(el_24, {
                        fontSize: 20,
                    })),
                    label: "Adresse",
                    value: (event.Address.length > 0) ? event.Address : event.Region.Name,
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let elems_6, el_26, elems_5, el_28;
                    const matchValue_1 = event.DateDescription;
                    if (matchValue_1 == null) {
                        return empty();
                    }
                    else {
                        const dateDescription = matchValue_1;
                        return singleton_1(createElement("div", createObj(ofArray([["style", {
                            border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                            borderRadius: 6,
                            marginTop: 8,
                            maxHeight: 300,
                            overflow: "hidden",
                        }], (elems_6 = [(el_26 = Caption1Strong, createElement(el_26, {
                            style: {
                                paddingTop: 6,
                                paddingLeft: 6,
                                display: "block",
                                textTransform: "uppercase",
                                letterSpacing: 0.5 + "px",
                                color: tokens.colorNeutralForeground3,
                            },
                            children: "Tidsoversikt",
                        })), createElement("div", createObj(ofArray([["style", {
                            maxHeight: 300,
                            overflow: "auto",
                            padding: ((8 + "px ") + 8) + "px",
                        }], (elems_5 = [(el_28 = Body1, createElement(el_28, {
                            style: {
                                whiteSpace: "pre-wrap",
                            },
                            children: dateDescription,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                    }
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(isMobile ? singleton_1(["padding", ((16 + "px ") + 16) + "px"]) : singleton_1(["padding", ((16 + "px ") + 24) + "px"]), delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["flexDirection", "column"]), delay(() => append_1(singleton_1(["gap", 14 + "px "]), delay(() => singleton_1(["borderTop", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2]))))))))))))], (elems_14 = toList(delay(() => {
        let elems_9, elems_8, el_30, el_32, el_34;
        return append_1((canManage && (event.MaxAttendees > 0)) ? singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 6 + "px ",
        }], (elems_9 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
        }], (elems_8 = [(el_30 = Caption1Strong, createElement(el_30, {
            style: {
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                color: tokens.colorNeutralForeground3,
            },
            children: "Påmeldte",
        }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), (el_32 = ProgressBar, createElement(el_32, {
            value: min(1, max(0, event.AttendeeCount / max(1, event.MaxAttendees))),
            thickness: "medium",
            shape: "rounded",
            color: "brand",
        })), (el_34 = Caption1, createElement(el_34, {
            style: {
                display: "block",
                color: tokens.colorNeutralForeground3,
            },
            children: `Påmeldte ${event.AttendeeCount}/ ${event.MaxAttendees}`,
        }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty(), delay(() => {
            let elems_13;
            return singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8 + "px ",
            }], (elems_13 = toList(delay(() => append_1(canManage ? singleton_1(createElement(Dialog_1, {
                event: event,
                replaceEvent: (arg_1) => {
                    dispatch(new Msg(0, [arg_1]));
                },
            })) : singleton_1(createElement(PrimaryAction, {
                event: event,
                model: model,
                dispatch: dispatch,
            })), delay(() => append_1(canManage ? append_1(singleton_1(createElement(CloseSignupDialog, {
                event: event,
                onClosed: (arg_3) => {
                    dispatch(new Msg(0, [arg_3]));
                },
                isOpen: patternInput_1[0],
                setIsOpen: setCloseSignupOpen,
            })), delay(() => singleton_1(createElement(DeleteEventDialog, {
                event: event,
                isOpen: patternInput_2[0],
                setIsOpen: setDeleteOpen,
            })))) : empty(), delay(() => {
                let el_70, elems_12, el_40, el_38, el_36, el_68, elems_11, el_66, elems_10, elemsToUse;
                return singleton_1((el_70 = Menu, createElement(el_70, createObj(ofArray([["positioning", {
                    position: "below",
                    align: "end",
                }], (elems_12 = [(el_40 = MenuTrigger, createElement(el_40, {
                    disableButtonEnhancement: true,
                    children: (el_38 = Button, createElement(el_38, {
                        appearance: "transparent",
                        icon: (el_36 = MoreVerticalRegular, createElement(el_36, {})),
                        "aria-label": "Flere handlinger",
                    })),
                })), (el_68 = MenuPopover, createElement(el_68, createObj(singleton((elems_11 = [(el_66 = MenuList, createElement(el_66, createObj(singleton((elems_10 = toList(delay(() => {
                    let el_44, el_42;
                    return append_1((canManage && canCloseSignup(event)) ? append_1(singleton_1((el_44 = MenuItem, createElement(el_44, {
                        icon: (el_42 = LockClosedRegular, createElement(el_42, {})),
                        children: "Lukk påmelding",
                        onClick: (_arg) => {
                            setCloseSignupOpen(true);
                        },
                    }))), delay(() => {
                        let el_46;
                        return singleton_1((el_46 = MenuDivider, createElement(el_46, {})));
                    })) : empty(), delay(() => {
                        let el_50, el_48;
                        return append_1(singleton_1((el_50 = MenuItem, createElement(el_50, {
                            icon: (el_48 = CalendarLtrRegular, createElement(el_48, {})),
                            children: "Legg til i Google Kalender",
                            disabled: event.Finalized,
                            onClick: (_arg_1) => {
                                typeof window !== 'undefined' ? window.open(googleCalendarUrl(event), '_blank', 'noopener,noreferrer') : null;
                            },
                        }))), delay(() => {
                            let el_54, el_52;
                            return append_1(singleton_1((el_54 = MenuItem, createElement(el_54, {
                                icon: (el_52 = MailRegular, createElement(el_52, {})),
                                children: "Legg til i Outlook",
                                disabled: event.Finalized,
                                onClick: (_arg_2) => {
                                    typeof window !== 'undefined' ? window.open(outlookCalendarUrl(event), '_blank', 'noopener,noreferrer') : null;
                                },
                            }))), delay(() => {
                                let el_58, el_56;
                                return canManage ? append_1(singleton_1((el_58 = MenuItem, createElement(el_58, {
                                    icon: (el_56 = DocumentArrowDownRegular, createElement(el_56, {})),
                                    children: "Eksportér deltakerliste",
                                    onClick: (_arg_3) => {
                                        const pr = tap((res) => {
                                            if (res.tag === 1) {
                                                errorToast(setCtx, "", "Noe gikk galt", `${res.fields[0]}`, undefined);
                                            }
                                            else {
                                                ByteArrayExtensions_SaveFileAs_5EF83E14(res.fields[0], `${event.Name}.xlsx`);
                                            }
                                        }, startAsPromise(Report.EventAttendees(event.Id)));
                                        void (pr.catch((ex) => {
                                            toastServerError(setCtx, ex);
                                        }));
                                    },
                                }))), delay(() => {
                                    let el_60;
                                    return append_1(singleton_1((el_60 = MenuDivider, createElement(el_60, {}))), delay(() => {
                                        let el_64, el_62;
                                        return singleton_1((el_64 = MenuItem, createElement(el_64, {
                                            icon: (el_62 = DeleteRegular, createElement(el_62, {
                                                primaryFill: tokens.colorStatusDangerForeground1,
                                            })),
                                            children: "Slett arrangement",
                                            style: {
                                                color: tokens.colorStatusDangerForeground1,
                                            },
                                            disabled: event.Finalized,
                                            onClick: (_arg_4) => {
                                                setDeleteOpen(true);
                                            },
                                        })));
                                    }));
                                })) : empty();
                            }));
                        }));
                    }));
                })), ["children", reactApi_1.Children.toArray(Array.from(elems_10))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])))))], (elemsToUse = ((length(elems_12) <= 2) ? elems_12 : take(2, elems_12)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])))));
            })))))), ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_14))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["alignItems", "center"]), delay(() => append_1(singleton_1(["gap", 14 + "px "]), delay(() => append_1(singleton_1(["flexWrap", "wrap"]), delay(() => append_1(isMobile ? singleton_1(["padding", ((12 + "px ") + 16) + "px"]) : singleton_1(["padding", ((14 + "px ") + 24) + "px"]), delay(() => append_1(singleton_1(["backgroundColor", tokens.colorNeutralBackground2]), delay(() => singleton_1(["borderTop", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2]))))))))))))))))], (elems_15 = toList(delay(() => {
        let el_72;
        return append_1(singleton_1((el_72 = Caption1Strong, createElement(el_72, {
            style: {
                color: tokens.colorNeutralForeground3,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginRight: 4,
            },
            children: (event.SecondaryTeachers.length > 0) ? "Kursholdere" : "Kursholder",
        }))), delay(() => append_1(singleton_1(createElement(TeacherChip, {
            teacher: event.Teacher,
            label: "Kursholder",
            canLink: canViewProfile,
            small: false,
        })), delay(() => map_1((t_1) => createElement(TeacherChip, {
            teacher: t_1,
            label: "Sekundær kursholder",
            canLink: canViewProfile,
            small: true,
        }), event.SecondaryTeachers)))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_16))])])));
}

function OmPanel(event) {
    let elems_8;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 24 + "px ",
    }], (elems_8 = toList(delay(() => {
        let matchValue, d, d_1, elems, el;
        return append_1((matchValue = event.Description, (matchValue != null) ? (((d = matchValue, d.length > 0)) ? ((d_1 = matchValue, singleton_1(createElement("section", createObj(singleton((elems = [createElement(SectionEyebrow, {
            label: "Kommentar fra kursholder",
        }), (el = Body1, createElement(el, {
            style: {
                color: tokens.colorNeutralForeground2,
                whiteSpace: "pre-wrap",
            },
            children: d_1,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))]))))))) : (empty())) : (empty())), delay(() => {
            let elems_1;
            return append_1(((event.Course.Summary.length > 0) ? true : exists((d_2) => (d_2.length > 0), toArray(event.Course.Description))) ? singleton_1(createElement("section", createObj(singleton((elems_1 = toList(delay(() => append_1(singleton_1(createElement(SectionEyebrow, {
                label: "Om kurset",
            })), delay(() => {
                let el_2;
                return append_1((event.Course.Summary.length > 0) ? singleton_1((el_2 = Body1, createElement(el_2, {
                    style: {
                        color: tokens.colorNeutralForeground2,
                        display: "block",
                    },
                    children: event.Course.Summary,
                }))) : empty(), delay(() => {
                    let el_4, d_3;
                    const matchValue_1 = event.Course.Description;
                    let matchResult, d_4;
                    if (matchValue_1 != null) {
                        if ((d_3 = matchValue_1, d_3.length > 0)) {
                            matchResult = 0;
                            d_4 = matchValue_1;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return singleton_1((el_4 = Caption1, createElement(el_4, {
                                style: {
                                    color: tokens.colorNeutralForeground2,
                                    display: "block",
                                    marginTop: 6,
                                    whiteSpace: "pre-wrap",
                                },
                                children: d_4,
                            })));
                        default: {
                            return empty();
                        }
                    }
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))]))))) : empty(), delay(() => {
                let elems_7, el_16, elems_6, elems_5, elems_2, el_6, elems_3, el_8, el_10, elems_4, el_12, el_14;
                return (event.Address.length > 0) ? singleton_1(createElement("section", createObj(singleton((elems_7 = [createElement(SectionEyebrow, {
                    label: "Adresse",
                }), (el_16 = Card, createElement(el_16, createObj(ofArray([["style", {
                    padding: 0,
                    overflow: "hidden",
                }], (elems_6 = [createElement("iframe", {
                    src: mapsEmbedUrl(event.Address),
                    title: "Kart",
                    style: {
                        width: 100 + "%",
                        height: 200,
                        border: (((0 + "px ") + "none") + " ") + "transparent",
                    },
                    loading: "lazy",
                    referrerPolicy: "no-referrer-when-downgrade",
                }), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 12 + "px ",
                    padding: ((14 + "px ") + 16) + "px",
                    borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
                    width: 36,
                    height: 36,
                    borderRadius: 18,
                    backgroundColor: tokens.colorBrandBackground2,
                    color: tokens.colorBrandForeground1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }], (elems_2 = [(el_6 = LocationRegular, createElement(el_6, {
                    fontSize: 20,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    minWidth: 0,
                }], (elems_3 = [(el_8 = Body2, createElement(el_8, {
                    style: {
                        display: "block",
                        color: tokens.colorNeutralForeground1,
                    },
                    children: event.Address,
                })), (el_10 = Caption1, createElement(el_10, {
                    style: {
                        display: "block",
                        color: tokens.colorNeutralForeground3,
                    },
                    children: event.Region.Name,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("a", createObj(ofArray([["href", mapsUrl(event.Address)], ["target", "_blank"], ["rel", "noopener noreferrer"], ["style", {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6 + "px ",
                    padding: ((8 + "px ") + 12) + "px",
                    borderRadius: 6,
                    border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                    backgroundColor: tokens.colorNeutralBackground1,
                    color: tokens.colorNeutralForeground1,
                    textDecoration: "none",
                }], (elems_4 = [(el_12 = OpenRegular, createElement(el_12, {
                    fontSize: 16,
                })), (el_14 = Caption1Strong, createElement(el_14, {
                    children: "Åpne i kart",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_7))]))))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

function OppgaverPanel(oppgaverPanelInputProps) {
    let elems_10;
    const dispatch = oppgaverPanelInputProps.dispatch;
    const model = oppgaverPanelInputProps.model;
    const event = oppgaverPanelInputProps.event;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const totalTasks = event.Course.Tasks.length | 0;
    let completedCount;
    const array_2 = event.Course.Tasks.filter((task) => model.UserCompletedTasks.some((ct) => (ct.Task.Id === task.Id)));
    completedCount = array_2.length;
    return createElement("section", createObj(singleton((elems_10 = toList(delay(() => {
        let elems_2, el_12, elems_1, el_4, el_2, el, el_10, elems, el_6, text_1, el_8, elemsToUse;
        return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 10,
            gap: 12 + "px ",
            flexWrap: "wrap",
        }], (elems_2 = [createElement(SectionEyebrow, {
            label: `Oppgaver · ${completedCount}/${totalTasks} fullført`,
        }), (el_12 = Popover, createElement(el_12, createObj(ofArray([["positioning", "before"], (elems_1 = [(el_4 = PopoverTrigger, createElement(el_4, {
            children: (el_2 = Button, createElement(el_2, {
                icon: (el = QuestionRegular, createElement(el, {})),
                appearance: "subtle",
                size: "small",
            })),
        })), (el_10 = PopoverSurface, createElement(el_10, createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            maxWidth: isMobile ? (75 + "vw") : (400 + "px"),
        }], (elems = [(el_6 = Subtitle2, createElement(el_6, {
            children: "Godkjenning av oppgaver",
        })), (text_1 = "Hvis arrangementet inneholder oppgaver du selv kan markere som fullført, vises en avkrysningsboks ved disse. For øvrige oppgaver er det kursholder som må godkjenne gjennomføringen. Oppgaver kan ikke markeres som gjennomført før arrangementet har begynt.", (el_8 = Caption1, createElement(el_8, {
            children: text_1,
        })))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], (elemsToUse = ((length(elems_1) <= 2) ? elems_1 : take(2, elems_1)), ["children", reactApi_1.Children.toArray(elemsToUse)]))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let el_16, elems_3, el_14, el_40, elems_9;
            return (totalTasks === 0) ? singleton_1((el_16 = Card, createElement(el_16, createObj(ofArray([["style", {
                padding: ((16 + "px ") + 18) + "px",
            }], (elems_3 = [(el_14 = Body2, createElement(el_14, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: "Ingen oppgaver knyttet til dette arrangementet.",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))) : singleton_1((el_40 = Card, createElement(el_40, createObj(ofArray([["style", {
                padding: 0,
                overflow: "hidden",
            }], (elems_9 = toList(delay(() => collect((matchValue_1) => {
                let elems_8;
                const task_1 = matchValue_1[1];
                const userHasCompleted = model.UserCompletedTasks.some((ct_1) => (ct_1.Task.Id === task_1.Id));
                return singleton_1(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["alignItems", "center"]), delay(() => append_1(singleton_1(["gap", 14 + "px "]), delay(() => append_1(singleton_1(["padding", ((14 + "px ") + 16) + "px"]), delay(() => ((matchValue_1[0] > 0) ? singleton_1(["borderTop", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2]) : empty()))))))))))))], (elems_8 = toList(delay(() => {
                    let elems_4;
                    return append_1(singleton_1(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["width", 24]), delay(() => append_1(singleton_1(["height", 24]), delay(() => append_1(singleton_1(["borderRadius", 12]), delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["alignItems", "center"]), delay(() => append_1(singleton_1(["justifyContent", "center"]), delay(() => append_1(singleton_1(["flexShrink", 0]), delay(() => (userHasCompleted ? append_1(singleton_1(["backgroundColor", tokens.colorStatusSuccessForeground1]), delay(() => singleton_1(["color", tokens.colorNeutralForegroundOnBrand]))) : append_1(singleton_1(["border", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1]), delay(() => singleton_1(["color", tokens.colorNeutralForeground3])))))))))))))))))))))], (elems_4 = toList(delay(() => {
                        let el_18, el_20, el_22;
                        return userHasCompleted ? singleton_1((el_18 = CheckmarkRegular, createElement(el_18, {
                            fontSize: 16,
                        }))) : (task_1.VerificationRequired ? singleton_1((el_20 = LockClosedRegular, createElement(el_20, {
                            fontSize: 16,
                        }))) : singleton_1((el_22 = CircleRegular, createElement(el_22, {
                            fontSize: 16,
                        }))));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                        let elems_5;
                        return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            minWidth: 0,
                            gap: 2 + "px ",
                        }], (elems_5 = toList(delay(() => {
                            let el_24;
                            return append_1(singleton_1((el_24 = Body2, createElement(el_24, {
                                style: createObj(toList(delay(() => append_1(singleton_1(["display", "block"]), delay(() => append_1(singleton_1(["color", tokens.colorNeutralForeground1]), delay(() => (userHasCompleted ? append_1(singleton_1(["textDecoration", "line-through"]), delay(() => singleton_1(["color", tokens.colorNeutralForeground3]))) : empty())))))))),
                                children: task_1.Name,
                            }))), delay(() => {
                                let el_26;
                                return (task_1.Description.length > 0) ? singleton_1((el_26 = Caption1, createElement(el_26, {
                                    style: {
                                        display: "block",
                                        color: tokens.colorNeutralForeground3,
                                    },
                                    children: task_1.Description,
                                }))) : empty();
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                            let el_31, matchValue_3, el_28, el_38, matchValue_4;
                            const matchValue_2 = model.UserAttendanceStatus;
                            switch (matchValue_2.tag) {
                                case 1:
                                case 2:
                                    return !task_1.VerificationRequired ? singleton_1((el_31 = Tooltip, createElement(el_31, createObj(ofArray([["content", userHasCompleted ? "Marker som ikke fullført" : "Marker som fullført"], (matchValue_3 = tryHead([(el_28 = Checkbox, createElement(el_28, {
                                        checked: userHasCompleted,
                                        disabled: compare(event.Time, utcNow()) >= 0,
                                        onChange: (_arg, c) => {
                                            const _b = Checkbox_toBool(c);
                                            if (userHasCompleted) {
                                                Promises_revokeTask(event.Id, task_1.Id, ctx.User, dispatch, setCtx);
                                            }
                                            else {
                                                Promises_completeTask(event.Id, task_1.Id, ctx.User, dispatch, setCtx);
                                            }
                                        },
                                    }))]), (matchValue_3 == null) ? ["children", defaultOf()] : ["children", matchValue_3])]))))) : singleton_1((el_38 = Tooltip, createElement(el_38, createObj(ofArray([["content", userHasCompleted ? "Godkjent" : (`Må godkjennes av ${event.Teacher.FirstName} ${event.Teacher.LastName}`)], (matchValue_4 = tryHead(toList(delay(() => {
                                        let el_33, el_35;
                                        return userHasCompleted ? singleton_1((el_33 = CheckmarkRegular, createElement(el_33, {
                                            primaryFill: tokens.colorStatusSuccessForeground1,
                                            fontSize: 20,
                                        }))) : singleton_1((el_35 = Avatar, createElement(el_35, {
                                            size: 24,
                                            color: "colorful",
                                            name: `${event.Teacher.FirstName} ${event.Teacher.LastName}`,
                                            image: {
                                                src: defaultArg(event.Teacher.ThumbnailUrl, ""),
                                            },
                                        })));
                                    }))), (matchValue_4 == null) ? ["children", defaultOf()] : ["children", matchValue_4])])))));
                                default:
                                    return singleton_1(defaultOf());
                            }
                        }));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
            }, indexed(event.Course.Tasks)))), ["children", reactApi_1.Children.toArray(Array.from(elems_9))])])))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_10))]))));
}

export function View(viewInputProps) {
    let elems_9, elems, el, el_2, el_4;
    const eventId = viewInputProps.eventId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const patternInput_2 = reactApi.useState("om");
    const activeTab = patternInput_2[0];
    useEffectOnce(() => {
        Promises_fetchEvent(eventId, dispatch, setCtx);
        Promises_fetchUserCompletedTasks(dispatch, setCtx);
        Promises_checkIsAttending(eventId, dispatch, setCtx);
    });
    const dependencies = [model_1.Event];
    reactApi.useEffect(() => {
        const matchValue = model_1.Event;
        if (matchValue != null) {
            Promises_checkIsEligible(matchValue.Course.Id, dispatch, setCtx);
        }
    }, dependencies);
    const matchValue_1 = model_1.Event;
    if (matchValue_1 != null) {
        const event_1 = matchValue_1;
        const canManage = canUserManageEvent(patternInput[0].User, event_1);
        const showMobileBottomBar = (equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []))) && !canManage;
        return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["flexDirection", "column"]), delay(() => append_1(singleton_1(["gap", 1.5 + "rem"]), delay(() => (showMobileBottomBar ? singleton_1(["paddingBottom", 5 + "rem"]) : empty()))))))))))], (elems_9 = toList(delay(() => append_1(singleton_1(createElement(SignedUpDialog, {
            event: event_1,
            model: model_1,
            dispatch: dispatch,
        })), delay(() => append_1(singleton_1(createElement(WithdrawConfirmDialog, {
            event: event_1,
            model: model_1,
            dispatch: dispatch,
        })), delay(() => append_1(singleton_1(createElement(HeroCard, {
            event: event_1,
            model: model_1,
            dispatch: dispatch,
            canManage: canManage,
        })), delay(() => {
            let elems_6, el_18, elems_5;
            return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
                overflowX: "auto",
            }], (elems_6 = [(el_18 = TabList, createElement(el_18, createObj(ofArray([["selectedValue", activeTab], ["onTabSelect", (_arg_2, value_1_2) => {
                patternInput_2[1](value_1_2.value);
            }], (elems_5 = toList(delay(() => {
                let el_8;
                return append_1(singleton_1((el_8 = Tab, createElement(el_8, {
                    value: "om",
                    children: "Om arrangementet",
                }))), delay(() => {
                    let el_12, elems_2, elems_1, el_10;
                    return append_1(singleton_1((el_12 = Tab, createElement(el_12, createObj(ofArray([["value", "oppgaver"], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 6 + "px ",
                    }], (elems_1 = [createElement("span", {
                        children: ["Oppgaver"],
                    }), (el_10 = CounterBadge, createElement(el_10, {
                        count: event_1.Course.Tasks.length,
                        appearance: "filled",
                        size: "small",
                        showZero: true,
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))), delay(() => {
                        let el_16, elems_4, elems_3, el_14;
                        return canManage ? singleton_1((el_16 = Tab, createElement(el_16, createObj(ofArray([["value", "deltakere"], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 6 + "px ",
                        }], (elems_3 = [createElement("span", {
                            children: ["Deltakere"],
                        }), (el_14 = CounterBadge, createElement(el_14, {
                            count: event_1.AttendeeCount,
                            appearance: "filled",
                            size: "small",
                            showZero: true,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))) : empty();
                    }));
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                let matchValue_2;
                return append_1((matchValue_2 = activeTab, (matchValue_2 === "om") ? singleton_1(createElement(OmPanel, event_1)) : ((matchValue_2 === "oppgaver") ? singleton_1(createElement(OppgaverPanel, {
                    event: event_1,
                    model: model_1,
                    dispatch: dispatch,
                })) : ((matchValue_2 === "deltakere") ? (canManage ? singleton_1(createElement(Panel, {
                    eventId: event_1.Id,
                })) : singleton_1(defaultOf())) : singleton_1(defaultOf())))), delay(() => {
                    let elems_8, elems_7;
                    return ((showMobileBottomBar && (compare(event_1.Time, now_1()) > 0)) && !event_1.Finalized) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 30,
                        padding: ((10 + "px ") + 14) + "px",
                        backgroundColor: tokens.colorNeutralBackground1,
                        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                        display: "flex",
                        gap: 8 + "px ",
                        alignItems: "center",
                    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
                        flexGrow: 1,
                    }], (elems_7 = [createElement(PrimaryAction, {
                        event: event_1,
                        model: model_1,
                        dispatch: dispatch,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty();
                }));
            }));
        })))))))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
    }
    else if (model_1.IsFetchingEventDetails) {
        const el_6 = Skeleton;
        return createElement(el_6, createObj(ofArray([["style", {
            width: 100 + "%",
            display: "flex",
            flexDirection: "column",
            gap: 25 + "px ",
        }], (elems = [(el = SkeletonItem, createElement(el, {
            style: {
                height: 35 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_2 = SkeletonItem, createElement(el_2, {
            style: {
                height: 20 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_4 = SkeletonItem, createElement(el_4, {
            style: {
                height: 20 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
    else {
        return notFoundView();
    }
}

//# sourceMappingURL=EventView.jsx.map
